<app-side-menu>
  <div class="staff-form-container">
    <!-- Loading overlay -->
    <app-loading
      [show]="loading"
      [message]="'Carregando dados da configuração...'"
      [size]="'medium'"
      [overlay]="true">
    </app-loading>

    <!-- Header -->
    <div class="form-header">
      <h1>
        <i class="fas" [ngClass]="isEditMode ? 'fa-edit' : 'fa-plus-circle'"></i>
        {{ isEditMode ? 'Editar Configuração de OS' : 'Nova Configuração de OS' }}
      </h1>
      <p>{{ isEditMode ? 'Edite as configurações da ordem de serviço' : 'Configure um novo tipo de ordem de serviço' }}</p>
    </div>

    <!-- Cabeçalho fixo: abas + nome da OS -->
    <div class="form-sticky-header">
      <div class="tabs-navigation">
        <div 
          *ngFor="let tab of availableTabs" 
          class="tab-item" 
          [class.active]="activeTab === tab.id"
          [class.completed]="tab.completed"
          (click)="selectTab(tab.id)">
          <i [class]="tab.icon"></i>
          <span class="tab-label">{{ tab.label }}</span>
          <span class="required-indicator" *ngIf="tab.required">*</span>
        </div>
      </div>

      <div class="os-name-context" [class.os-name-context--empty]="!formData.typeOS?.trim()">
        <i class="fas fa-tag"></i>
        <span class="os-name-context-label">Nome da OS:</span>
        <strong class="os-name-context-value">{{ formData.typeOS?.trim() || 'Não informado' }}</strong>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab-content">
      <!-- Mensagens de Sucesso/Erro -->
      <div class="alert alert-success" *ngIf="successMessage">
        <i class="fas fa-check-circle me-2"></i>
        {{ successMessage }}
      </div>
      <div class="alert alert-danger" *ngIf="error">
        <i class="fas fa-exclamation-circle me-2"></i>
        {{ error }}
      </div>

      <!-- Aba: Dados da Configuração -->
      <div class="tab-panel" *ngIf="activeTab === 'basic'">
        <div class="detail-section">
          <h3><i class="fas fa-file-alt"></i> Dados Básicos</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <label for="typeOS">Nome da OS *</label>
              <input 
                type="text" 
                id="typeOS" 
                [(ngModel)]="formData.typeOS"
                (ngModelChange)="updateTabsCompletionStatus()"
                placeholder="Ex: Manutenção Preventiva"
                [class.is-invalid]="!formData.typeOS">
              <div class="invalid-feedback" *ngIf="!formData.typeOS">
                Nome da OS é obrigatório
              </div>
            </div>

            <div class="detail-item">
              <label for="departmentId">Departamento *</label>
              <select 
                id="departmentId" 
                [(ngModel)]="formData.departmentId"
                (ngModelChange)="updateTabsCompletionStatus()"
                [class.is-invalid]="!formData.departmentId"
                [disabled]="loadingDepartments">
                <option [value]="null" disabled>{{ loadingDepartments ? 'Carregando...' : 'Selecione um departamento' }}</option>
                <option *ngFor="let dept of departments" [value]="dept.id">
                  {{ dept.name }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="!formData.departmentId">
                Departamento é obrigatório
              </div>
            </div>

            <div class="detail-item">
              <label for="groupId">Grupo *</label>
              <select 
                id="groupId" 
                [(ngModel)]="formData.groupId"
                (ngModelChange)="onGroupIdChange()"
                [class.is-invalid]="!formData.groupId"
                [disabled]="loadingGroups">
                <option [value]="null" disabled>{{ loadingGroups ? 'Carregando...' : 'Selecione um grupo' }}</option>
                <option *ngFor="let group of groups" [value]="group.id">
                  {{ group.name }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="!formData.groupId">
                Grupo é obrigatório
              </div>
              <small class="form-text text-muted" *ngIf="serviceOrderNumberExample">
                Exemplo de Nº de OS: <strong>{{ serviceOrderNumberExample }}</strong>
              </small>
            </div>

            <div class="detail-item">
              <label for="serviceOrderType">Tipo de Ordem de Serviço</label>
              <select
                id="serviceOrderType"
                [(ngModel)]="formData.isThirdParty">
                <option [ngValue]="false">OS Normal</option>
                <option [ngValue]="true">OS Terceiros</option>
              </select>
            </div>

            <div class="detail-item" style="grid-column: 1 / -1;">
              <label for="description">Descrição</label>
              <textarea 
                id="description" 
                [(ngModel)]="formData.description"
                rows="4"
                placeholder="Descrição detalhada da configuração da OS"></textarea>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h3><i class="fas fa-sliders-h"></i> Opções</h3>
          <div class="detail-grid">
            <div class="detail-item" style="grid-column: 1 / -1;">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="allowSelectVehicle"
                  [(ngModel)]="formData.allowSelectVehicle">
                <label class="form-check-label" for="allowSelectVehicle">
                  Selecionar Veículo
                  <i
                    class="fas fa-info-circle text-info ms-2"
                    title="Possibilita atrelar um veículo e assim trazendo automaticamente Contrato e Cliente à OS."></i>
                </label>
              </div>

              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="allowSelectCustomer"
                  [(ngModel)]="formData.allowSelectCustomer">
                <label class="form-check-label" for="allowSelectCustomer">
                  Selecionar Cliente
                  <i
                    class="fas fa-info-circle text-info ms-2"
                    title="Ao adicionar um Cliente à OS ele trará o contrato e o veículo caso exista."></i>
                </label>
              </div>

              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="allowSelectStock"
                  [(ngModel)]="formData.allowSelectStock">
                <label class="form-check-label" for="allowSelectStock">
                  Selecionar Estoque
                  <i
                    class="fas fa-info-circle text-info ms-2"
                    title="Permite direcionar as peças e o serviço a um estoque específico."></i>
                </label>
              </div>

              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="allowAddServices"
                  [(ngModel)]="formData.allowAddServices">
                <label class="form-check-label" for="allowAddServices">
                  Adicionar Serviços
                  <i
                    class="fas fa-info-circle text-info ms-2"
                    title="Possibilita adicionar vários tipos de serviços com custos ou não para o cliente."></i>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba: Regras & Encerramento -->
      <div class="tab-panel" *ngIf="activeTab === 'rules'">
        <div class="detail-section">
          <h3><i class="fas fa-clipboard-check"></i> Regras e Encerramento</h3>
          
          <div class="detail-grid">
            <div class="detail-item">
              <div class="form-check form-switch">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  id="hasTransaction"
                  [(ngModel)]="formData.hasTransaction">
                <label class="form-check-label" for="hasTransaction">
                  <span class="me-2">Possui Transação</span>
                  <i class="fas fa-info-circle text-info" title="Define se este tipo de OS utiliza regras de transação (status/direcionamento)"></i>
                </label>
              </div>
              <small class="form-text text-muted">
                {{ formData.hasTransaction ? 'Esta OS utilizará regras de transação.' : 'Esta OS não utilizará regras de transação.' }}
              </small>
            </div>

            <div class="detail-item">
              <div class="form-check form-switch">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  id="canClosed"
                  [(ngModel)]="formData.canClosed"
                  (ngModelChange)="onCanClosedChange($event)">
                <label class="form-check-label" for="canClosed">
                  <span class="me-2">Pode ser Encerrada</span>
                  <i class="fas fa-info-circle text-info" title="Define se este tipo de OS pode ser encerrada"></i>
                </label>
              </div>
              <small class="form-text text-muted">
                {{ formData.canClosed ? 'Esta OS poderá ser encerrada.' : 'Esta OS não poderá ser encerrada.' }}
              </small>
            </div>

            <div class="detail-item" *ngIf="formData.canClosed">
              <label for="closingStatusId">Status que permite encerramento</label>
              <select
                id="closingStatusId"
                [(ngModel)]="formData.closingStatusId"
                (ngModelChange)="onClosingStatusIdChange($event)"
                [disabled]="loadingStatuses || !statuses.length"
                [class.is-invalid]="formData.canClosed && !formData.closingStatusId">
                <option [ngValue]="null" disabled>
                  {{ loadingStatuses ? 'Carregando status...' : (statuses.length ? 'Selecione o status de encerramento' : 'Cadastre ao menos um status') }}
                </option>
                <option *ngFor="let status of statuses" [ngValue]="status.id">
                  {{ status.name }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="formData.canClosed && !formData.closingStatusId">
                Selecione o status que permitirá o encerramento.
              </div>
            </div>

            <div class="detail-item">
              <div class="form-check form-switch">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  id="isActive"
                  [(ngModel)]="formData.isActive">
                <label class="form-check-label" for="isActive">
                  <span class="me-2">Ativo</span>
                  <i class="fas fa-info-circle text-info" title="Define se esta configuração está ativa"></i>
                </label>
              </div>
              <small class="form-text text-muted">
                {{ formData.isActive ? 'Esta configuração está ativa.' : 'Esta configuração está inativa.' }}
              </small>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="formData.hasTransaction">
          <h3><i class="fas fa-random"></i> Status & Direcionamentos</h3>

          <div class="detail-grid">
            <div class="detail-item">
              <label for="excludeStatus">Adicionar Status</label>
              <div class="inline-actions">
                <input
                  type="text"
                  id="excludeStatus"
                  [(ngModel)]="newExcludedStatusName"
                  placeholder="Ex: Aprovado"
                  (keyup.enter)="addStatus()">

                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="addStatus()"
                  [disabled]="!(newExcludedStatusName && newExcludedStatusName.trim())">
                  Adicionar
                </button>
              </div>
              <small class="form-text text-muted">
                Crie os status disponíveis para OS.
              </small>
            </div>

            <div class="detail-item">
              <label>Status cadastrados</label>
              <div class="chips" *ngIf="statuses.length; else noExcludedStatuses">
                <div class="chip" *ngFor="let status of statuses">
                  <span class="chip-label">{{ status.name }}</span>
                  <button type="button" class="chip-remove" (click)="removeStatusById(status.id)" aria-label="Remover status">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <ng-template #noExcludedStatuses>
                <div class="empty-hint">
                  Nenhum status adicionado.
                </div>
              </ng-template>
            </div>

            <div class="detail-item">
              <label for="openingReason">Adicionar Motivos de Abertura</label>

              <div class="inline-actions">
                <select
                  id="openingReason"
                  [(ngModel)]="selectedSystemReasonName"
                  class="form-control"
                  [disabled]="loadingSystemReasons || showCustomOpeningReasonInput">
                  <option value="">{{ loadingSystemReasons ? 'Carregando motivos...' : 'Selecione um motivo pré-cadastrado' }}</option>
                  <option *ngFor="let name of availableSystemReasonNames" [value]="name">{{ name }}</option>
                </select>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="addOpeningReasonFromSelect()"
                  [disabled]="!selectedSystemReasonName || showCustomOpeningReasonInput">
                  Adicionar
                </button>
              </div>

              <div style="margin-top: 8px;">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  (click)="toggleCustomOpeningReasonInput()">
                  <i class="fas" [ngClass]="showCustomOpeningReasonInput ? 'fa-minus' : 'fa-plus'"></i>
                  {{ showCustomOpeningReasonInput ? 'Cancelar novo motivo' : 'Adicionar novo motivo' }}
                </button>
              </div>

              <div class="inline-actions" style="margin-top: 8px;" *ngIf="showCustomOpeningReasonInput">
                <input
                  type="text"
                  [(ngModel)]="newOpeningReasonName"
                  placeholder="Ex: Abertura por Garantia"
                  (keyup.enter)="addOpeningReason()">

                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="addOpeningReason()"
                  [disabled]="!(newOpeningReasonName && newOpeningReasonName.trim())">
                  Adicionar
                </button>
              </div>

              <small class="form-text text-muted">
                Selecione um motivo pré-cadastrado ou adicione um novo caso necessário.
              </small>
            </div>

            <div class="detail-item">
              <label>Motivos de abertura cadastrados</label>

              <div class="chips" *ngIf="openingReasons.length; else noOpeningReasons">
                <div class="chip" *ngFor="let reason of openingReasons">
                  <span class="chip-label">{{ reason.statusName }}</span>
                  <button
                    type="button"
                    class="chip-remove"
                    (click)="removeOpeningReasonById(reason.id)"
                    aria-label="Remover status de abertura">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <ng-template #noOpeningReasons>
                <div class="empty-hint">
                  {{ loadingOpeningReasons ? 'Carregando...' : 'Nenhum status de abertura adicionado.' }}
                </div>
              </ng-template>
            </div>

            <div class="detail-item" style="grid-column: 1 / -1;">
              <label>Criar tramitação (passo a passo)</label>

              <div class="rule-help">
                <div class="rule-help-title">Como Funciona</div>
                <div class="rule-help-text">
                  Uma <strong>Transação</strong> define o que acontece quando a OS estiver em um <strong>Status inicial</strong>.
                  Você escolhe se ela <strong>permanece na mesma OS</strong> (mesma Config. OS) ou se <strong>vai para outra Config. OS</strong>,
                  e então define o <strong>Status de destino</strong>.
                </div>
              </div>

              <div class="rule-builder">
                <div class="rule-step">
                  <div class="step-title">1) Status inicial</div>
                  <select
                    [(ngModel)]="newRule.firstStatusId"
                    [disabled]="loadingStatuses">
                    <option [ngValue]="null" disabled>
                      {{ loadingStatuses ? 'Carregando status...' : 'Selecione o status inicial' }}
                    </option>
                    <option *ngFor="let status of statuses" [ngValue]="status.id">
                      {{ status.name }}
                    </option>
                  </select>
                  <small class="form-text text-muted">Quando a OS estiver neste status…</small>
                </div>

                <div class="rule-step">
                  <div class="step-title">2) Permanece na mesma OS?</div>
                  <select
                    [(ngModel)]="destinationMode"
                    (ngModelChange)="onDestinationModeChange($event)"
                    [disabled]="!hasPersistedConfigOrder">
                    <option [ngValue]="'same'">Sim (Ficará no mesmo setor)</option>
                    <option [ngValue]="'other'">Não (Irá para outro setor)</option>
                  </select>
                  <small class="form-text text-muted">
                    Se for “Não”, selecione a Config. OS destino no próximo passo.
                  </small>
                </div>

                <div class="rule-step" *ngIf="destinationMode === 'other'">
                  <div class="step-title">3) Config. OS destino</div>
                  <select
                    [(ngModel)]="newRule.targetConfigOrderId"
                    (ngModelChange)="onTargetConfigOrderChange()"
                    [disabled]="!allConfigOrders.length">
                    <option [ngValue]="null" disabled>Selecione a Config. OS destino</option>
                    <option *ngFor="let config of allConfigOrders" [ngValue]="config.id">
                      {{ config.typeOS }}
                    </option>
                  </select>
                  <small class="form-text text-muted">
                    Esta seleção carrega os status disponíveis no destino.
                  </small>
                </div>

                <div class="rule-step">
                  <div class="step-title">{{ destinationMode === 'other' ? '4) Status destino' : '3) Status destino' }}</div>
                  <select
                    [(ngModel)]="newRule.statusDirectionId"
                    [disabled]="loadingTargetStatuses || (destinationMode === 'other' && !newRule.targetConfigOrderId)">
                    <option [ngValue]="null" disabled>
                      {{ loadingTargetStatuses ? 'Carregando status...' : 'Selecione o status destino' }}
                    </option>
                    <option *ngFor="let status of targetStatuses" [ngValue]="status.id">
                      {{ status.name }}
                    </option>
                  </select>
                  <small class="form-text text-muted">…então ela irá para este status.</small>
                </div>

                <div class="rule-step" *ngIf="destinationMode === 'other'">
                  <div class="step-title">Grupo</div>
                  <select
                    [(ngModel)]="newRule.groupId"
                    [disabled]="loadingGroups">
                    <option [ngValue]="null" disabled>
                      {{ loadingGroups ? 'Carregando grupos...' : 'Selecione o grupo' }}
                    </option>
                    <option *ngFor="let group of groups" [ngValue]="group.id">
                      {{ group.name }}
                    </option>
                  </select>
                  <small class="form-text text-muted">Define para qual grupo esta tramitação vale.</small>
                </div>

                <div class="rule-actions">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="addTransactionRule()"
                    [disabled]="loadingTransactionRules || !newRule.firstStatusId || !newRule.statusDirectionId || (destinationMode === 'other' && (!newRule.targetConfigOrderId || !newRule.groupId))">
                    Adicionar Transação
                  </button>

                  <div class="rule-preview" *ngIf="newRule.firstStatusId && newRule.statusDirectionId">
                    <div class="rule-preview-title">Resumo</div>
                    <div class="rule-preview-text">
                      Quando estiver em <strong>{{ getStatusName(newRule.firstStatusId) }}</strong>,
                      <span *ngIf="destinationMode === 'same'">
                        permanece na mesma OS e vai para <strong>{{ getStatusName(newRule.statusDirectionId) }}</strong>.
                      </span>
                      <span *ngIf="destinationMode === 'other'">
                        tramita para <strong>{{ getConfigOrderTypeName(newRule.targetConfigOrderId) }}</strong>
                        no status <strong>{{ getStatusName(newRule.statusDirectionId) }}</strong>.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="detail-item" style="grid-column: 1 / -1;">
              <label>Regras cadastradas</label>
              <div class="direction-table" *ngIf="transactionRules.length; else noRules">
                <div class="direction-row direction-header">
                  <div>Passo a passo</div>
                  <div class="direction-actions-header">Ações</div>
                </div>
                <div class="direction-row" *ngFor="let rule of transactionRules">
                  <div class="direction-status">
                    <div class="rule-line">
                      <span class="rule-key">1) Status inicial:</span>
                      <span class="rule-value">{{ rule.firstStatusName || getStatusName(rule.firstStatusId) }}</span>
                    </div>
                    <div class="rule-line">
                      <span class="rule-key">2) Transação:</span>
                      <span class="rule-value">
                        <span class="badge bg-success">Sim</span>
                      </span>
                    </div>
                    <div class="rule-line">
                      <span class="rule-key">3) Permanece no mesmo Setor?</span>
                      <span class="rule-value">
                        <ng-container *ngIf="getRuleStaysInSameConfig(rule) === null">—</ng-container>
                        <ng-container *ngIf="getRuleStaysInSameConfig(rule) === true">
                          <span class="badge bg-success">Sim</span>
                        </ng-container>
                        <ng-container *ngIf="getRuleStaysInSameConfig(rule) === false">
                          <span class="badge bg-secondary">Não</span>
                        </ng-container>
                      </span>
                    </div>
                    <div class="form-text rule-note" *ngIf="getRuleStaysInSameConfig(rule) === false">
                      OBS: Irá para outro setor
                    </div>
                    <div class="form-text rule-note" *ngIf="getRuleStaysInSameConfig(rule) === true">
                      OBS: Permanece no mesmo setor
                    </div>
                    <div class="rule-line">
                      <span class="rule-key">4) Destino / Status de Destino:</span>
                      <span class="rule-value">
                        <ng-container *ngIf="getRuleDestinationConfigOrderType(rule)">
                          {{ getRuleDestinationConfigOrderType(rule) }} / 
                        </ng-container>
                        {{ rule.statusDirectionName || getStatusName(rule.statusDirectionId) }}
                      </span>
                    </div>
                    <div class="form-text">
                      Grupo: {{ getGroupName(rule.groupId) }}
                    </div>
                  </div>
                  <div class="direction-actions">
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      (click)="removeTransactionRule(rule.id)">
                      Excluir regra
                    </button>
                  </div>
                </div>
              </div>

              <ng-template #noRules>
                <div class="empty-hint">
                  Nenhuma regra cadastrada.
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba: Status de Veiculo -->
      <div class="tab-panel" *ngIf="activeTab === 'vehicle-status'">
        <div class="detail-section">
          <h3><i class="fas fa-car"></i> Situação do Veiculo</h3>

          <div class="detail-grid">
            <div class="detail-item" style="grid-column: 1 / -1;">
              <label>Definir situação do veículo</label>

              <div class="inline-actions">
                <select
                  [(ngModel)]="newVehicleInitialStatusId"
                  [disabled]="loadingStatuses || !statuses.length">
                  <option [ngValue]="null" disabled>
                    {{ loadingStatuses ? 'Carregando status...' : (statuses.length ? 'Selecione o status da OS' : 'Cadastre ao menos um status') }}
                  </option>
                  <option *ngFor="let status of statuses" [ngValue]="status.id">
                    {{ status.name }}
                  </option>
                </select>

                <input
                  type="text"
                  [(ngModel)]="newVehicleStatusText"
                  placeholder="Ex: Disponível"
                  (keyup.enter)="addVehicleStatusChange()">

                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="addVehicleStatusChange()"
                  [disabled]="!(newVehicleInitialStatusId && newVehicleStatusText && newVehicleStatusText.trim())">
                  Salvar
                </button>
              </div>

              <small class="form-text text-muted">
                Exemplo: Quando situação for <strong>Aberta</strong>, a situação do veículo será <strong>Disponível</strong>.
              </small>
            </div>

            <div class="detail-item" style="grid-column: 1 / -1;">
              <label>Regras cadastradas</label>

              <div class="chips" *ngIf="vehicleStatusChanges.length; else noVehicleStatusChanges">
                <div class="chip" *ngFor="let rule of vehicleStatusChanges">
                  <span class="chip-label">{{ rule.initialStatusName }} → {{ rule.newStatusVeichile }}</span>
                  <button
                    type="button"
                    class="chip-remove"
                    (click)="removeVehicleStatusChangeById(rule.id)"
                    aria-label="Remover regra">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <ng-template #noVehicleStatusChanges>
                <div class="empty-hint">
                  {{ loadingVehicleStatusChanges ? 'Carregando...' : 'Nenhuma regra adicionada.' }}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- Botões de Navegação -->
      <div class="navigation-buttons">
        <app-button 
          *ngIf="!isFirstTab()"
          text="Anterior" 
          color="#495057" 
          (buttonClick)="goToPreviousTab()" 
          className="btn-outline-secondary">
          <i class="fas fa-arrow-left me-2"></i>
        </app-button>

        <app-button 
          text="Cancelar" 
          color="var(--danger-color)" 
          (buttonClick)="onCancel()" 
          className="btn-outline-danger">
          <i class="fas fa-times me-2"></i>
        </app-button>

        <app-button 
          *ngIf="!isLastTab()"
          text="" 
          color="var(--primary-color)" 
          (buttonClick)="goToNextTab()" 
          [disabled]="saving"
          className="btn-primary">
          <ng-container *ngIf="saving && activeTab === 'basic' && !hasPersistedConfigOrder; else nextLabel">
            Salvando...
            <i class="fas fa-spinner fa-spin ms-2"></i>
          </ng-container>
          <ng-template #nextLabel>
            Próximo
            <i class="fas fa-arrow-right ms-2"></i>
          </ng-template>
        </app-button>

        <app-button 
          *ngIf="isLastTab()"
          text="{{ saving ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Salvar') }}" 
          color="var(--primary-color)" 
          (buttonClick)="onSave()" 
          [disabled]="saving"
          className="btn-success">
          <i class="fas fa-save me-2" *ngIf="!saving"></i>
          <i class="fas fa-spinner fa-spin me-2" *ngIf="saving"></i>
        </app-button>
      </div>
    </div>
  </div>
</app-side-menu>
